const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const filter1 = ["7","15","26","40"];
const filter2 = ["8","14","29","42"];
const filter3 = ["5","17","24","49"];
const filter4 = ["5","18","25","48"];
const filter5 = ["9","14","29","42"];
const filter6 = ["4","13","29","50"];
const filter7 = ["4","13","23","47"];
const filter8 = ["3","13","29","45"];
const filter9 = ["4","13","29","44"];

const successStoryTeaser = (filters) => {
    const tags = filters.map((filter) => {
        return `<span class="ux-tag" data-ux-iws-link-wrapper-ignore data-ux-success-story-tag="${filter}">Tag ${filter}</span>`
    }).join("");
    return `
<ux-iws-teaser-image image-ratio="17:8" class="ux-u-margin-bottom-30" data-ux-success-story-filter="${filters.join(",")}">
    ${filters[0] === "7" ? `` : `<div slot="image">
        <picture>
            <source media="(max-width: 567px)" />
            <source media="(max-width: 1024px)" />
            <source />
            <img src="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 1929 904%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E" />
        </picture>
    </div>`}
    <div slot="tags">
        ${tags}
    </div>
    <strong class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase" slot="label">
        teaser box label
    </strong>
    <h5 class="ux-u-margin-top-0 ux-u-margin-bottom-10 ux-text-headline ux-text-headline--medium" slot="headline">
       ${filters[0] !== "9" ? "Teaser box headline" : "A really long headline for the teaser of the success"}
    </h5>
    <ux-text-lines-limit text-lines="4" slot="text">
        <div class="ux-text-normal ux-text-normal--light-gray">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et. sed diam voluptua. At vero eos et
            accusam et justo duo dolores et. Lorem ipsum dolor sit amet, consetetur sadipscing
            elitr, sed diam nonumy nvidunt ut labore et dolore magna aliquyam erat.
        </div>
    </ux-text-lines-limit>
    <div slot="cta">
        <a class="ux-button ux-button--icon-only" href="#">
            <ux-icon name="chevron-right" weight="normal"></ux-icon>
        </a>
    </div>
</ux-iws-teaser-image>`;
}

const quoteTeaser = () => `
   <div class="ux-u-margin-bottom-30" data-ux-success-story-filter="">
        <div class="ux-u-margin-top-20 ux-u-margin-m-top-70 ux-u-margin-bottom-25 ux-u-margin-left-20 ux-u-margin-right-10">
            <ux-icon name="quotation-mark" class="ux-color-success" size-s="55" weight="bold"></ux-icon>
            <h5 class="headline-small ux-u-margin-top-5 ux-u-margin-bottom-10">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                invidunt ut labore et dolore magna
            </h5>
            <div class="text-tiny u-uppercase">
                <strong>Medium Title</strong>
            </div>
        </div>
   </div>
`;

export interface SuccessStoriesResponse {
    arguments: any;
    data: SuccessStoryData;
    message: string;
    status: string;
}

interface SuccessStoryData {
    elements: {
        html: string;
    }[]
}

const dataElements = (withQuotes: boolean) => {
    const results = [
        { html: successStoryTeaser(filter1) },
        { html: successStoryTeaser(filter2) },
        { html: successStoryTeaser(filter3) },
        { html: successStoryTeaser(filter2) },
        { html: withQuotes ? quoteTeaser() : `` },
        { html: successStoryTeaser(filter1) },
        { html: successStoryTeaser(filter2) },
        { html: successStoryTeaser(filter3) },
        { html: withQuotes ? quoteTeaser() : `` },
        { html: successStoryTeaser(filter4) },
        { html: successStoryTeaser(filter2) },
        { html: successStoryTeaser(filter3) },
        { html: successStoryTeaser(filter5) },
        { html: withQuotes ? quoteTeaser() : `` },
        { html: successStoryTeaser(filter1) },
        { html: successStoryTeaser(filter6) },
        { html: successStoryTeaser(filter7) },
        { html: successStoryTeaser(filter8) },
        { html: successStoryTeaser(filter9) },
    ]
    return [...results, ...results, ...results, ...results];
}

const response: (withQuotes: boolean) => SuccessStoriesResponse = (withQuotes = true) => ({
    data: {
        elements: dataElements(withQuotes)
    },
    message: "Success",
    status: "success",
    arguments: {
        L: "0",
        id: "21",
        locale: "de_INT",
        pageUid: "6512/",
        type: 42,
    },
})

const writeToFile = (object: SuccessStoriesResponse, file: string) => {
    fs.writeFileSync(`${output}${file}`, JSON.stringify(object));
};

writeToFile(response(true), "success-stories.json");
writeToFile(response(false), "success-stories-no-quotes.json");
